import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import LoginLogo from 'assets/images/login-logo.svg';
import Theme from 'theme';
import { palette } from 'theme/palette';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Cory Foster DDS',
  tokenName: 'drcoryfosterSubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  headerProps: {
    enable: true,
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {},
      secondaryButton: 'Login',
      secondaryButtonProps: {
        to: '/login',
        variant: 'contained',
        color: 'primary',
        style: { backgroundColor: palette.text.brand },
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-tab.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      alignTitle: 'center',
      alignCard: 'center',
      heroImage: '/images/home-images/benefits-hero.webp',
    },
    subscriptionSection: {
      priority: 'top',
      renderAsTabsLimit: 4,
      cardVariant: 1,
      tabVariant: 1,
      disableGroupSavings: true,
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      carouselResponsiveItems: {
        desktop: 3,
      },
      planCardProps: {
        buttonProps: {
          customSpace: 11,
          normalVariant: 'outlined',
          normalColor: 'primary',
          to: '/find-a-provider',
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: false,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
        variant: 'contained',
        style: { backgroundColor: palette.text.brand },
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
  },
  savingsSummary: {
    enableFooterbar: true,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
  },
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: LoginLogo,
  },
  theme: Theme,
};

export default config;
